import { createRouter, createWebHistory } from '@ionic/vue-router';
import HomePage from '../views/HomePage.vue';
import LandingPage from '../views/LandingPage.vue';
import PreferencesPage from '../views/PreferencesPage.vue';
import StartRedirect from '../views/StartRedirect.vue';
import EndRedirect from '../views/EndRedirect.vue';
import { Auth } from '@/services/AuthService';
import { filter, switchMap, take } from 'rxjs/operators';
import CampusAppPage from '@/views/CampusAppPage.vue';
import ClickAndLearnAppPage from '@/views/ClickAndLearnAppPage.vue';
import AccountPage from "@/views/AccountPage.vue";
import CampusCentralSettingsPage from "@/views/CampusCentralSettingsPage.vue";
import ClickAndLearnSettingsPage from "@/views/ClickAndLearnSettingsPage.vue";
import ELearningAppPage from "@/views/ELearningAppPage.vue";
import OpenIdSignIn from "@/views/OpenIdSignIn.vue";
import * as Sentry from "@sentry/capacitor";
const routes = [
    {
        path: '/',
        redirect: '/home',
    },
    {
        path: '/home',
        name: 'Home',
        component: HomePage,
        meta: { requiresAuth: true }
    },
    {
        path: '/landing',
        name: 'Landing',
        component: LandingPage,
        meta: { requiresAuth: false, layout: 'layout-guest' }
    },
    {
        path: '/open-id-sign-in',
        name: 'OpenIdSignIn',
        component: OpenIdSignIn,
        meta: { requiresAuth: false, layout: 'layout-guest' }
    },
    {
        path: '/preferences',
        name: 'Preferences',
        component: PreferencesPage,
        meta: { layout: 'layout-guest' }
    },
    {
        path: '/preferences/account',
        name: 'Account',
        component: AccountPage,
        meta: { requiresAuth: true }
    },
    {
        path: '/preferences/campus-central',
        name: 'CampusCentralSettings',
        component: CampusCentralSettingsPage,
        meta: { requiresAuth: true }
    },
    {
        path: '/preferences/click-and-learn',
        name: 'ClickAndLearnSettings',
        component: ClickAndLearnSettingsPage,
        meta: { requiresAuth: true }
    },
    {
        path: '/authcallback',
        name: 'Redirect',
        component: StartRedirect
    },
    {
        path: '/endsession',
        name: 'EndRedirect',
        component: EndRedirect
    },
    {
        path: '/campus-app',
        name: 'CampusApp',
        component: CampusAppPage,
        meta: { requiresAuth: true }
    },
    {
        path: '/click-and-learn-app',
        name: 'ClickAndLearnApp',
        component: ClickAndLearnAppPage,
        meta: { requiresAuth: true }
    },
    {
        path: '/e-learning-app',
        name: 'ELearningAppPage',
        component: ELearningAppPage,
        meta: { requiresAuth: true }
    }
];
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});
router.beforeEach((to, from, next) => {
    if (!to.meta.requiresAuth) {
        return next();
    }
    Sentry.addBreadcrumb({
        category: 'router',
        message: 'BeforeEach triggered',
        level: 'info',
        data: { to: to.name, from: from.name }
    });
    Auth.Instance.initComplete$
        .pipe(filter(complete => complete), switchMap(() => Auth.Instance.isAuthenticated$), take(1))
        .subscribe(async (isAuthenticated) => {
        Sentry.addBreadcrumb({
            category: 'auth',
            message: 'isAuthenticated check',
            level: 'info',
            data: { isAuthenticated }
        });
        if (isAuthenticated) {
            return next();
        }
        Sentry.addBreadcrumb({
            category: 'auth',
            message: 'User NOT authenticated → refreshing token…',
            level: 'warning'
        });
        await Auth.Instance.refreshToken();
        Auth.Instance.isAuthenticated$
            .pipe(take(1))
            .subscribe(async (isAuthenticated) => {
            Sentry.addBreadcrumb({
                category: 'auth',
                message: 'After refresh check',
                level: isAuthenticated ? 'info' : 'error',
                data: { isAuthAfterRefresh: isAuthenticated }
            });
            if (!isAuthenticated) {
                Sentry.captureMessage("Router: Refresh token failed", {
                    level: 'error',
                    extra: { to: to.name, from: from.name }
                });
                console.log('Router: Refresh failed, redirect to landing');
                Auth.clearUserData();
                return next('/landing');
            }
            return next();
        });
    });
});
export default router;
